import { useEffect } from 'react'

interface Sentinel {
  release(): Promise<void>
}

type WakeLockNavigator = Navigator & {
  wakeLock?: { request(type: 'screen'): Promise<Sentinel> }
}

/**
 * V obchode nesmi zhasinat obrazovka — sestra ma v jedne ruce kosik.
 * Prohlizec zamek uvolni pri prepnuti do jine aplikace, proto se znovu
 * zada pri navratu.
 */
export function useWakeLock(active = true): void {
  useEffect(() => {
    const nav = navigator as WakeLockNavigator
    if (!active || !nav.wakeLock) return

    let lock: Sentinel | null = null
    let cancelled = false

    async function acquire() {
      if (!nav.wakeLock || document.visibilityState !== 'visible') return
      try {
        const next = await nav.wakeLock.request('screen')
        if (cancelled) void next.release()
        else lock = next
      } catch {
        // napr. usporny rezim baterie — appka funguje i bez zamku
      }
    }

    const onVisible = () => {
      if (document.visibilityState === 'visible') void acquire()
    }

    void acquire()
    document.addEventListener('visibilitychange', onVisible)
    return () => {
      cancelled = true
      document.removeEventListener('visibilitychange', onVisible)
      void lock?.release()
    }
  }, [active])
}
